import React from 'react';

// ═══════════════════════════════════════════════════════════════════════════
// Sprites SVG partagés — voitures, panneaux, cyclistes, feux
// À injecter UNE SEULE FOIS dans une page qui utilise plusieurs scènes.
// ═══════════════════════════════════════════════════════════════════════════

export function SvgSpritesDefs() {
  return (
    <svg width="0" height="0" style={{ position: 'absolute' }} aria-hidden="true">
      <defs>
        {/* Voiture "currentColor" — teinte via style={{color:...}} sur le parent */}
        <g id="cv-car">
          <rect x="-18" y="-32" width="36" height="64" rx="16" fill="currentColor" stroke="#20252b" strokeWidth={2} />
          <ellipse cx={0} cy={-12} rx={13} ry={9} fill="#111" />
          <ellipse cx={0} cy={16} rx={12} ry={7} fill="#111" />
          <circle cx={-10} cy={-25} r={4} fill="#fff" />
          <circle cx={10} cy={-25} r={4} fill="#fff" />
        </g>
        {/* Camion / poids lourd */}
        <g id="cv-truck">
          <rect x="-28" y="-80" width="56" height="160" rx={8} fill="#455a64" stroke="#1b1f22" strokeWidth={3} />
          <rect x="-24" y="-78" width="48" height="45" fill="#f9a825" />
          <circle cx={-31} cy={55} r={9} fill="#222" />
          <circle cx={31} cy={55} r={9} fill="#222" />
        </g>
        {/* Vélo */}
        <g id="cv-velo">
          <circle cx={-18} cy={12} r={10} fill="none" stroke="#fff" strokeWidth={4} />
          <circle cx={20} cy={12} r={10} fill="none" stroke="#fff" strokeWidth={4} />
          <path d="M-18 12 L0 -8 L10 12 L-5 12 L20 12 M0 -8 L8 -22" fill="none" stroke="#fff" strokeWidth={4} strokeLinecap="round" />
          <circle cx={9} cy={-27} r={5} fill="#fff" />
        </g>
        {/* Panneau Cédez-le-passage */}
        <g id="cv-yield">
          <polygon points="0,24 24,-18 -24,-18" fill="#fff" stroke="#e53935" strokeWidth={5} />
        </g>
        {/* Panneau STOP */}
        <g id="cv-stop">
          <polygon points="0,-22 16,-16 22,0 16,16 0,22 -16,16 -22,0 -16,-16" fill="#e53935" stroke="#fff" strokeWidth={4} />
          <text x={0} y={5} textAnchor="middle" fontWeight="bold" fontSize={11} fontFamily="Arial" fill="#fff">STOP</text>
        </g>
        {/* Panneau Route prioritaire */}
        <g id="cv-priority">
          <rect x={-18} y={-18} width={36} height={36} transform="rotate(45)" fill="#fff" stroke="#333" strokeWidth={2} />
          <rect x={-10} y={-10} width={20} height={20} transform="rotate(45)" fill="#f8c21a" />
        </g>
        {/* Feu tricolore */}
        <g id="cv-lights">
          <rect x={-12} y={-45} width={24} height={90} rx={10} fill="#111" />
          <circle cx={0} cy={-27} r={8} fill="#e53935" />
          <circle cx={0} cy={0} r={8} fill="#fdd835" />
          <circle cx={0} cy={27} r={8} fill="#43a047" />
        </g>
      </defs>
    </svg>
  );
}

// ═══════════════════════════════════════════════════════════════════════════
// Styles atomiques pour route / grass / lane markings
// ═══════════════════════════════════════════════════════════════════════════

const ROAD = "#7f8b95";
const GRASS = "#3a5f2c";        // vert foncé — meilleur contraste sur fond noir
const SAND = "#7a6444";
const LANE = { stroke: '#fff', strokeWidth: 3, strokeDasharray: '16 16', strokeLinecap: 'round' };
const SOLID = { stroke: '#fff', strokeWidth: 3, strokeLinecap: 'round' };

// ═══════════════════════════════════════════════════════════════════════════
// Scène 1 · Carrefour à feux
// ═══════════════════════════════════════════════════════════════════════════

export function SceneCarrefourFeux() {
  return (
    <svg viewBox="0 0 600 620" data-scene role="img" aria-label="Carrefour à feux avec voitures déplaçables">
      <rect fill={SAND} width={600} height={620} />
      <rect fill={ROAD} x={0} y={190} width={600} height={235} />
      <rect fill={ROAD} x={155} y={0} width={290} height={620} />
      <line {...LANE} x1={230} y1={30} x2={230} y2={580} />
      <line {...LANE} x1={300} y1={30} x2={300} y2={580} />
      <line {...LANE} x1={370} y1={30} x2={370} y2={580} />
      <line {...LANE} x1={20} y1={270} x2={580} y2={270} />
      <line {...LANE} x1={20} y1={345} x2={580} y2={345} />
      <path className="cv-route" d="M230 570 C230 420 230 320 190 245 C160 205 120 200 40 200" />
      <g transform="translate(180 150)"><use href="#cv-lights" /></g>
      <g transform="translate(290 150)"><use href="#cv-lights" /></g>
      <g transform="translate(405 150)"><use href="#cv-lights" /></g>
      <g className="cv-drag" style={{ color: '#e53935' }} transform="translate(230 540)"><use href="#cv-car" /></g>
      <g className="cv-drag" style={{ color: '#1e9bd7' }} transform="translate(370 535)"><use href="#cv-car" /></g>
    </svg>
  );
}

// ═══════════════════════════════════════════════════════════════════════════
// Scène 2 · Carrefour stop
// ═══════════════════════════════════════════════════════════════════════════

export function SceneCarrefourStop() {
  return (
    <svg viewBox="0 0 520 620" data-scene role="img" aria-label="Carrefour avec panneaux STOP">
      <rect fill={GRASS} width={520} height={620} />
      <rect fill={ROAD} x={0} y={245} width={520} height={130} />
      <rect fill={ROAD} x={195} y={0} width={130} height={620} />
      <line {...LANE} x1={260} y1={20} x2={260} y2={600} />
      <line {...LANE} x1={20} y1={310} x2={500} y2={310} />
      <line {...SOLID} x1={325} y1={245} x2={400} y2={245} />
      <line {...SOLID} x1={120} y1={375} x2={195} y2={375} />
      <path className="cv-route" d="M260 590 C260 460 260 390 330 340 C380 305 435 305 500 305" />
      <g transform="translate(350 210)"><use href="#cv-stop" /></g>
      <g transform="translate(125 380) rotate(180)"><use href="#cv-stop" /></g>
      <g className="cv-drag" style={{ color: '#1e9bd7' }} transform="translate(260 560)"><use href="#cv-car" /></g>
    </svg>
  );
}

// ═══════════════════════════════════════════════════════════════════════════
// Scène 3 · Priorité à droite / route prioritaire
// ═══════════════════════════════════════════════════════════════════════════

export function ScenePrioriteRoutePrio() {
  return (
    <svg viewBox="0 0 560 620" data-scene role="img" aria-label="Intersection avec route prioritaire">
      <rect fill={GRASS} width={560} height={620} />
      <rect fill={ROAD} x={0} y={245} width={560} height={130} />
      <rect fill={ROAD} x={215} y={0} width={130} height={620} />
      <line {...LANE} x1={280} y1={20} x2={280} y2={600} />
      <line {...LANE} x1={20} y1={310} x2={540} y2={310} />
      <path className="cv-route" d="M280 590 C280 450 280 360 410 310 C455 292 510 292 545 292" />
      <g transform="translate(110 205)"><use href="#cv-yield" /></g>
      <g transform="translate(405 200)"><use href="#cv-priority" /></g>
      <g transform="translate(420 405)"><use href="#cv-priority" /></g>
      <g className="cv-drag" style={{ color: '#43a047' }} transform="translate(280 555)"><use href="#cv-car" /></g>
    </svg>
  );
}

// ═══════════════════════════════════════════════════════════════════════════
// Scène 4 · Carrefour complexe avec cédez-le-passage
// ═══════════════════════════════════════════════════════════════════════════

export function SceneCarrefourComplexeYield() {
  return (
    <svg viewBox="0 0 620 760" data-scene role="img" aria-label="Carrefour complexe avec cédez-le-passage">
      <rect fill={SAND} width={620} height={760} />
      <rect fill={GRASS} x={0} y={0} width={145} height={190} />
      <rect fill={GRASS} x={470} y={0} width={150} height={190} />
      <rect fill={GRASS} x={0} y={500} width={145} height={260} />
      <rect fill={GRASS} x={470} y={500} width={150} height={260} />
      <rect fill={ROAD} x={145} y={0} width={325} height={760} />
      <rect fill={ROAD} x={0} y={245} width={620} height={190} />
      <line {...LANE} x1={308} y1={20} x2={308} y2={740} />
      <line {...LANE} x1={20} y1={340} x2={600} y2={340} />
      <line stroke="#fff" strokeWidth={3} strokeDasharray="10 12" fill="none" x1={145} y1={445} x2={235} y2={445} />
      <line stroke="#fff" strokeWidth={3} strokeDasharray="10 12" fill="none" x1={385} y1={245} x2={470} y2={245} />
      <use href="#cv-yield" x={135} y={220} />
      <use href="#cv-yield" x={485} y={220} />
      <use href="#cv-yield" x={135} y={470} />
      <use href="#cv-yield" x={485} y={470} />
      <path className="cv-route" d="M310 710 L310 450 C310 380 360 345 470 345" />
      <g className="cv-drag" style={{ color: '#1e9bd7' }} transform="translate(310 660)"><use href="#cv-car" /></g>
      <g className="cv-drag" style={{ color: '#f6c344' }} transform="translate(520 345) rotate(90)"><use href="#cv-car" /></g>
    </svg>
  );
}

// ═══════════════════════════════════════════════════════════════════════════
// Scène 5 · Carrefour complexe (multi-voies)
// ═══════════════════════════════════════════════════════════════════════════

export function SceneCarrefourComplexe() {
  return (
    <svg viewBox="0 0 620 760" data-scene role="img" aria-label="Carrefour complexe multi-voies">
      <rect fill={GRASS} width={620} height={760} />
      <rect fill={ROAD} x={0} y={420} width={620} height={150} />
      <rect fill={ROAD} x={230} y={0} width={140} height={420} />
      <rect fill={ROAD} x={230} y={570} width={140} height={190} />
      <rect fill={ROAD} x={0} y={150} width={620} height={120} />
      <line {...LANE} x1={300} y1={20} x2={300} y2={740} />
      <line {...LANE} x1={20} y1={495} x2={600} y2={495} />
      <line {...LANE} x1={20} y1={210} x2={600} y2={210} />
      <path className="cv-route" d="M300 730 C300 630 300 550 420 500 C490 470 555 470 610 470" />
      <g transform="translate(210 360)"><use href="#cv-yield" /></g>
      <g transform="translate(425 585)"><use href="#cv-yield" /></g>
      <g className="cv-drag" style={{ color: '#e53935' }} transform="translate(300 710)"><use href="#cv-car" /></g>
    </svg>
  );
}

// ═══════════════════════════════════════════════════════════════════════════
// Scène 6 · Giratoire simple (M5)
// ═══════════════════════════════════════════════════════════════════════════

export function SceneGiratoire() {
  return (
    <svg viewBox="0 0 620 620" data-scene role="img" aria-label="Giratoire à 4 branches">
      <rect fill={GRASS} width={620} height={620} />
      <circle fill={ROAD} cx={310} cy={310} r={150} />
      <circle fill="#5a8a2c" stroke="#e4c797" strokeWidth={15} cx={310} cy={310} r={70} />
      <rect fill={ROAD} x={280} y={0} width={60} height={190} />
      <rect fill={ROAD} x={280} y={430} width={60} height={190} />
      <rect fill={ROAD} x={0} y={280} width={190} height={60} />
      <rect fill={ROAD} x={430} y={280} width={190} height={60} />
      <circle fill="none" stroke="#fff" strokeWidth={4} strokeDasharray="20 15" cx={310} cy={310} r={115} />
      <path className="cv-route" d="M310 600 L310 450 C310 405 255 405 225 350 C195 290 230 220 300 205 C380 190 440 260 420 335 C405 395 365 425 340 450 L340 600" />
      <g transform="translate(240 475)"><use href="#cv-yield" /></g>
      <g transform="translate(460 245)"><use href="#cv-yield" /></g>
      <g className="cv-drag" style={{ color: '#f57c00' }} transform="translate(310 565)"><use href="#cv-car" /></g>
    </svg>
  );
}

// ═══════════════════════════════════════════════════════════════════════════
// Scène 7 · Rond-point avec angle mort camion (M5)
// ═══════════════════════════════════════════════════════════════════════════

export function SceneGiratoirePL() {
  return (
    <svg viewBox="0 0 620 760" data-scene role="img" aria-label="Giratoire avec poids lourd et angle mort">
      <rect fill={SAND} width={620} height={760} />
      <rect fill={GRASS} x={0} y={0} width={130} height={160} rx={30} />
      <rect fill={GRASS} x={490} y={0} width={130} height={160} rx={30} />
      <rect fill={GRASS} x={0} y={560} width={130} height={200} rx={30} />
      <rect fill={GRASS} x={490} y={560} width={130} height={200} rx={30} />
      <rect fill={ROAD} x={250} y={0} width={120} height={760} />
      <rect fill={ROAD} x={0} y={300} width={620} height={140} />
      <circle fill={ROAD} cx={310} cy={370} r={205} />
      <circle fill="#5a8a2c" stroke="#e0c894" strokeWidth={22} cx={310} cy={370} r={85} />
      <circle fill="none" stroke="#fff" strokeWidth={3} strokeDasharray="10 12" cx={310} cy={370} r={140} />
      <use href="#cv-yield" x={215} y={155} />
      <use href="#cv-yield" x={485} y={290} />
      <use href="#cv-yield" x={190} y={550} />
      <use href="#cv-yield" x={395} y={560} />
      <path className="cv-route" d="M310 700 L310 510 C310 420 380 420 395 355 C410 285 345 235 300 240" />
      <g className="cv-drag" style={{ color: '#f57c00' }} transform="translate(310 660)"><use href="#cv-car" /></g>
      <g className="cv-drag" transform="translate(188 345) rotate(90)"><use href="#cv-truck" /></g>
      <circle className="cv-zone" cx={245} cy={315} r={70} />
    </svg>
  );
}

// ═══════════════════════════════════════════════════════════════════════════
// Scène 8 · Boîte de vitesses / levier déplaçable (M1)
// Le point rouge du levier .cv-drag peut être déplacé sur le H de vitesses.
// La correction affiche une zone verte au bon rapport.
// ═══════════════════════════════════════════════════════════════════════════

export function SceneBoiteVitesses() {
  return (
    <svg viewBox="0 0 380 260" data-scene role="img" aria-label="Levier de vitesses déplaçable sur schéma en H">
      <rect width={380} height={260} fill="#1a1f26" />
      {/* Titre */}
      <text x={190} y={26} textAnchor="middle" fontFamily="Arial" fontSize={13} fill="#fff" opacity={0.7}>Manipule le levier — cible la 3ème</text>

      {/* Schéma en H — rapports */}
      <text x={30}  y={90}  fontFamily="Arial" fontWeight="bold" fontSize={22} fill="#e5e5e5">R</text>
      <text x={110} y={90}  fontFamily="Arial" fontWeight="bold" fontSize={22} fill="#e5e5e5">1</text>
      <text x={190} y={90}  fontFamily="Arial" fontWeight="bold" fontSize={22} fill="#e5e5e5">3</text>
      <text x={270} y={90}  fontFamily="Arial" fontWeight="bold" fontSize={22} fill="#e5e5e5">5</text>
      <text x={110} y={200} fontFamily="Arial" fontWeight="bold" fontSize={22} fill="#e5e5e5">2</text>
      <text x={190} y={200} fontFamily="Arial" fontWeight="bold" fontSize={22} fill="#e5e5e5">4</text>
      <text x={270} y={200} fontFamily="Arial" fontWeight="bold" fontSize={22} fill="#e5e5e5">6</text>
      {/* Rails du H */}
      <path d="M30 110 V180 H310 V110 M110 110 V180 M190 110 V180 M270 110 V180" stroke="#666" strokeWidth={10} fill="none" strokeLinecap="round" />
      {/* Zone cible (3ème) — révélée par la correction */}
      <circle className="cv-zone" cx={190} cy={145} r={28} />
      {/* Point de levier — déplaçable */}
      <circle className="cv-drag" cx={110} cy={145} r={15} fill="#dc2626" stroke="#fff" strokeWidth={2} />
    </svg>
  );
}

// ═══════════════════════════════════════════════════════════════════════════
// Scène 9 · Sas vélo (bonus)
// ═══════════════════════════════════════════════════════════════════════════

export function SceneSasVelo() {
  return (
    <svg viewBox="0 0 620 760" data-scene role="img" aria-label="Sas vélo à un feu tricolore">
      <rect fill={SAND} width={620} height={760} />
      <rect fill={GRASS} x={0} y={0} width={130} height={150} />
      <rect fill={GRASS} x={490} y={0} width={130} height={150} />
      <rect fill={GRASS} x={0} y={510} width={130} height={250} />
      <rect fill={GRASS} x={490} y={510} width={130} height={250} />
      <rect fill={ROAD} x={130} y={0} width={360} height={760} />
      <rect fill={ROAD} x={0} y={190} width={620} height={150} />
      <line {...LANE} x1={310} y1={20} x2={310} y2={740} />
      <line {...LANE} x1={25} y1={265} x2={595} y2={265} />
      {/* Passage piéton */}
      <g fill="#fff">
        {[145, 190, 235, 280, 325, 370].map((x) => <rect key={x} x={x} y={70} width={28} height={88} />)}
        {[165, 225, 285].map((y) => <rect key={y} x={445} y={y} width={88} height={25} />)}
      </g>
      {/* Sas vélo — hachures vertes */}
      <g opacity={0.75} fill="#4caf50">
        {[[365,100],[389,124],[365,148],[389,172],[365,196],[389,220],[365,244],[389,268],[365,292]].map(([x,y],i) => (
          <rect key={i} x={x} y={y} width={24} height={24} />
        ))}
      </g>
      <use href="#cv-velo" x={405} y={380} />
      <path className="cv-route" d="M405 680 L405 380 L405 90" />
      <g className="cv-drag" style={{ color: '#f57c00' }} transform="translate(235 660)"><use href="#cv-car" /></g>
    </svg>
  );
}
